import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {fetchAsyncUserDetails} from '../../Overview/OverviewSlice/UserDetailsSlice'
import {GeneralDataOFLoginUser} from '../../../../../Utils/Auth'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  PurchaseHistory: [],
  lowCreditData: [],
  messageNotification: [],
  reportsNotification: [],
}

export const updateAutotopup: any = createAsyncThunk(
  '/updateAutotopup',
  async (data: any, thunkApi) => {
    const response: any = await axios
      .put(`${API_URL}user/update-auto-popup-setting`, data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => {
        toast.success('updated successfully!')
      })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(fetchAsyncUserDetails())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const GetPurchaseHistory: any = createAsyncThunk(
  '/GetPurchaseHistory',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}user/get-user-orders/${data.id}`, {
      params: data.page,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)
export const UpdateLowCreditAlertSmsData: any = createAsyncThunk(
  '/UpdateLowCreditAlertSmsData',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(
      `${API_URL}user/updateOwnersLowCreditSetting`,
      {lowCreditSetting: data},
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    response?.data?.status
      ? toast?.success(response?.data?.message)
      : toast?.error(response?.data?.message)
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetLowCreditAlertSmsData())

    return response.data
  }
)
export const GetLowCreditAlertSmsData: any = createAsyncThunk(
  '/GetLowCreditAlertSmsData',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}user/getOwnersLowCreditSetting`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)
export const GetOwnersMessageNotificationSetting: any = createAsyncThunk(
  'GetOwnersMessageNotificationSetting',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}user/getOwnersMessageNotificationSetting`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)

export const GetOwnersReportSetting: any = createAsyncThunk(
  'GetOwnersReportSetting',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}user/getOwnersReportSetting`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)

export const UpdateOwnersReportSetting: any = createAsyncThunk(
  'UpdateOwnersReportSetting',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(
      `${API_URL}user/updateOwnersReportSetting`,
      {
        reportSettingDaily: data?.daily,
        reportSettingWeekly: data?.weekly,
        reportSettingMonthly: data?.monthly,
      },
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    response?.data?.status
      ? toast?.success(response?.data?.message)
      : toast?.error(response?.data?.message)
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetOwnersReportSetting())

    return response.data
  }
)

export const UpdateOwnersMessageNotificationSetting: any = createAsyncThunk(
  'UpdateOwnersMessageNotificationSetting',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(
      `${API_URL}user/updateOwnersMessageNotificationSetting`,
      {messageNotificationSetting: data},
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    response?.data?.status
      ? toast?.success(response?.data?.message)
      : toast?.error(response?.data?.message)
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetOwnersMessageNotificationSetting())

    return response.data
  }
)

const UserBilling = createSlice({
  name: 'UserBilling',
  initialState,
  reducers: {},
  extraReducers: {
    [GetPurchaseHistory.fulfilled]: (state, {payload}) => {
      return {...state, PurchaseHistory: payload.data}
    },
    [GetLowCreditAlertSmsData.fulfilled]: (state, {payload}) => {
      return {...state, lowCreditData: payload.data}
    },
    [GetOwnersMessageNotificationSetting.fulfilled]: (state, {payload}) => {
      return {...state, messageNotification: payload.data}
    },
    [GetOwnersReportSetting.fulfilled]: (state, {payload}) => {
      return {...state, reportsNotification: payload.data}
    },
  },
})

export default UserBilling.reducer
